
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import Sidebar from "@/components/Sidebar/index.vue";
import "../public/general.css";

const vuex = namespace("auth");

@Component({ components: { Sidebar } })
export default class App extends Vue {
  apiUrl = process.env.VUE_APP_API_URL as string;
  isLogged = false;
  avatar = "";

  @vuex.State("userLogged") userLogged!: any;
  @vuex.Getter("isLogged") isLoggedGetter!: boolean;

  @Watch("userLogged")
  onUserLoggedChanged(value: boolean) {
    if (value) {
      this.isLogged = this.isLoggedGetter;
      this.avatar = `${this.apiUrl}/images/avatar/${this.userLogged.avatar}`;
    }
  }
  @Watch("userLogged.avatar")
  onuserLoggedAvatarChange(value: any) {
    this.avatar = `${this.apiUrl}/images/avatar/${value}`;
  }

  created() {
    this.isLogged = this.isLoggedGetter;
    this.avatar = `${this.apiUrl}/images/avatar/${this.userLogged.avatar}`;
  }
}
